export default {
      id: "ic-fil-tv-light-white-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-tv-light-white-usage",
      toString: function () {
        return this.url;
      }
    }